// CurrencyDropdown.jsx
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { currencySymbols } from "../../constants";
import { useCurrency } from "../../Context/CurrencyContext";

const CurrencyDropdown = () => {
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const { updateRate } = useCurrency();

  useEffect(() => {
    const fetchCurrencies = () => {
      const currencyData = localStorage.getItem("currencyData");
      if (currencyData) {
        try {
          const { rates } = JSON.parse(currencyData);
          const formattedCurrencies = Object.entries(rates)
            .map(([currency, rate]) => ({ currency, rate }))
            .sort((a, b) => a.currency.localeCompare(b.currency));
          setCurrencies(formattedCurrencies);
        } catch (error) {
          console.error("Invalid currency data in localStorage", error);
        }
      }
    };

    const storedCurrency = localStorage.getItem("selectedCurrency");
    if (storedCurrency) {
      setSelectedCurrency(storedCurrency);
    }

    fetchCurrencies();
  }, []);

  const handleCurrencyChange = (event) => {
    const selected = event.target.value;
    localStorage.setItem("selectedCurrency", selected);
    const selectedCurrencyData = currencies.find(
      (c) => c.currency === selected
    );
    setSelectedCurrency(selected);
    if (selected === "USD") {
      updateRate({ $: 1 });
    } else if (selectedCurrencyData) {
      const symbol = currencySymbols[selected];
      updateRate({ [symbol]: selectedCurrencyData.rate });
    }
  };

  return (
    <FormControl sx={{ minWidth: { xs: 60, sm: 80 }, marginLeft: 2 }}>
      <InputLabel
        id="currency-select-label"
        sx={{ fontSize: { xs: "12px", sm: "14px" } }}
      >
        Currency
      </InputLabel>
      <Select
        labelId="currency-select-label"
        value={selectedCurrency}
        label="Currency"
        onChange={handleCurrencyChange}
        renderValue={(value) => `${value} ${currencySymbols[value] || ""}`}
        sx={{
          height: "40px",
          backgroundColor: "white",
          borderRadius: "4px",
          minWidth: 0,
          maxWidth: "100%",
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          fontSize: { xs: "14px", sm: "16px" },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 220,
              "& .MuiMenuItem-root": {
                fontSize: { xs: "14px", sm: "16px" },
                padding: { xs: "8px 12px", sm: "10px 16px" },
              },
              "&::-webkit-scrollbar": { width: "8px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#3F78E0",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-track": { backgroundColor: "#f0f0f0" },
            },
          },
        }}
      >
        <MenuItem
          value="USD"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            minWidth: { xs: 60, sm: 80 },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <span>USD</span>
        </MenuItem>
        {currencies.map(({ currency, rate }) => (
          <MenuItem
            key={currency}
            value={currency}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              minWidth: { xs: 60, sm: 80 },
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <span>{currency}</span>
            <span>{currencySymbols[currency]}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencyDropdown;
